import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { Title } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import { AppConfig } from "../configs/app";
import { RoutePaths } from "../configs/global";
import * as moment from "moment";
import * as _ from "lodash";

declare let $: any; /* JQUERY */
declare var Cleave: any; /* Cleave js FORMATTER */

@Injectable({
  providedIn: "root",
})
export class CommonService {
  public routePaths = RoutePaths;

  public jQuery: any;
  public Cleave: any;

  constructor(
    public router: Router,
    public httpClient: HttpClient,
    public titleService: Title,
    public appConfig: AppConfig,
    public translateService: TranslateService
  ) {
    this.jQuery = $;
    this.Cleave = Cleave;
  }

  redirectToRoute(path = "", params = [], queryParams = {}) {
    this.router.navigate([path, ...params], { queryParams: queryParams });
    return;
  }

  /* ATTRIBUTES: url, options (headers, params) */
  async sendHTTPGet(params: any) {
    return await this.httpClient
      .get(params.url, params.options)
      .toPromise()
      .then(function (res) {
        return res;
      })
      .catch(function (err) {
        console.log(err);
        return null;
      });
  }

  sendHTTPGetSync(params: any, callback: any) {
    return this.httpClient
      .get(params.url, params.options)
      .toPromise()
      .then(function (res) {
        callback(res);
      })
      .catch(function (err) {
        console.log(err);
        callback({ status: "fail" });
        return null;
      });
  }

  /* ATTRIBUTES: url, data, options (headers) */
  async sendHTTPPost(params: any) {
    return await this.httpClient
      .post(params.url, params.data, params.options)
      .toPromise()
      .then(function (res) {
        return res;
      })
      .catch(function (err) {
        console.log(err);
        return null;
      });
  }

  /* GET HEADER FOR BUSBOOKMARK APIs */
  getHTTPBusHeader(bypassAuth = false, isPayload = false) {
    let authToken = "";
    if (localStorage.getItem(this.appConfig.auth.loginSessionName) !== null) {
      let userData = JSON.parse(
        localStorage.getItem(this.appConfig.auth.loginSessionName)
      );
      authToken = `Bearer ${userData.token}`;
    }

    let header = {
      Authorization: authToken,
      "Content-Type": !isPayload
        ? "application/x-www-form-urlencoded"
        : "application/json; charset=utf-8",
    };
    /* REMOVE EMPTY Authorization TO AVOID SOME BROWSERS ISSUE */
    if (authToken == "") {
      delete header.Authorization;
    }

    return header;
  }

  isNumeric(number: any) {
    return !isNaN(parseFloat(number)) && isFinite(number);
  }

  // [CR-FRONT-06 F-8] Math.random()は暗号学的に安全でないため、
  // セキュリティ用途（OAuth state, CSRF token等）にはcrypto.getRandomValues()を使用
  getRandomString(length) {
    let text = "";
    let possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const randomValues = new Uint32Array(length);
    crypto.getRandomValues(randomValues);

    for (let i = 0; i < length; i++)
      text += possible.charAt(randomValues[i] % possible.length);
    return text;
  }

  getHash(key: any) {
    key = key.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var exp = key + "=([^&]*)";
    var regexp = new RegExp(exp);
    var results = regexp.exec(window.location.href);
    if (results == null) {
      return "";
    }
    return results[1];
  }

  /* FOR LOGIN PURPOSE */
  getCurrentURL() {
    let url = localStorage.getItem(this.appConfig.auth.currentURLSessionName);
    if (url === null) {
      return window.location.origin + this.routePaths.pageMyPageIndexNoParam;
    }
    return url;
  }

  setCurrentURL(
    url = window.location.origin + this.routePaths.pageMyPageIndexNoParam
  ) {
    localStorage.setItem(this.appConfig.auth.currentURLSessionName, url);
  }
  /* END */

  /* GET/SET/CLEAR LOCAL STORAGE */
  getData(key: any): any {
    if (key) {
      let data = localStorage.getItem(
        this.appConfig.localStoragePrefixName + key
      );
      data = JSON.parse(data);
      return data !== null ? data : null;
    }
    return null;
  }

  getNRemoveData(key: any): any {
    if (key) {
      let data = localStorage.getItem(
        this.appConfig.localStoragePrefixName + key
      );
      data = JSON.parse(data);
      if (data !== null) {
        this.removeData(key);
        return data;
      }
      return null;
    }
    return null;
  }

  setData(key: any, data: any) {
    if (key) {
      localStorage.setItem(
        this.appConfig.localStoragePrefixName + key,
        JSON.stringify(data)
      );
    }
  }

  // [CR-FRONT-06] バグ: setData()内部でもlocalStoragePrefixNameを付与するため
  //   clearData("foo") → setData("bus_ls_foo", null) → localStorage["bus_ls_bus_ls_foo"] = null
  //   元のキー "bus_ls_foo" は削除されない。現在どこからも呼ばれていないため実害なし。
  //   データ削除にはremoveData()またはremoveBatchData()を使用すること。
  clearData(key: any) {
    this.setData(this.appConfig.localStoragePrefixName + key, null);
  }

  removeData(key: any) {
    localStorage.removeItem(this.appConfig.localStoragePrefixName + key);
  }

  removeBatchData(keyArr: any = []) {
    for (let key of keyArr) {
      localStorage.removeItem(this.appConfig.localStoragePrefixName + key);
    }
  }
  /* END */

  /* FORMAT CURRENCY */
  formatCurrency(num: any = "", showEmptyLabel: boolean = false) {
    if (showEmptyLabel && !num) {
      return "-";
    }

    return String(num).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  stringPad(str: any = "", padLength: any = 2, padString: any = "0") {
    padLength = padLength >> 0; // TRUNCATE IF NUMBER OR CONVERT NON-NUMBER TO 0;
    padString = String(typeof padString !== "undefined" ? padString : " ");
    str = String(str);
    if (str.length > padLength) {
      return String(str);
    } else {
      padLength = padLength - str.length;
      if (padLength > padString.length) {
        padString += padString.repeat(padLength / padString.length); // APPEND TO ORIGINAL TO ENSURE WE ARE LONGER THAN NEEDED
      }
      return padString.slice(0, padLength) + String(str);
    }
    /* TEMP: return (str + "").padStart(padLength, padString); */
  }

  translate(key: string, data: any = {}) {
    return this.translateService.instant(key, data);
  }

  /* FOR UI BELOW */
  showPageLoader(message = "") {
    this.jQuery("#pageLoader .load-word").empty().html(this.translate(message));
    this.jQuery("#pageLoader").removeClass("d-none");
  }

  hidePageLoader() {
    this.jQuery("#pageLoader .load-word").empty().html("");
    this.jQuery("#pageLoader").addClass("d-none");
  }

  closeAllModals() {
    this.jQuery(".modal").modal("hide");
    this.jQuery(".modal-backdrop").remove();
    this.jQuery("html, body").removeClass("modal-open");
  }

  getDayLabel(day: number = -1) {
    let dayLabels = ["日", "月", "火", "水", "木", "金", "土"];
    if (day === -1) {
      return dayLabels;
    } else {
      if (dayLabels[day]) {
        return dayLabels[day];
      }
    }

    return "-";
  }

  getJQuery() {
    return this.jQuery;
  }

  getMoment() {
    return moment;
  }

  getLodash() {
    return _;
  }

  getCleave() {
    return this.Cleave;
  }

  objectToString(object) {
    return Object.keys(object)
      .map((key) => key + "=" + object[key])
      .join("&");
  }

  keyExists(key, search) {
    if (
      !search ||
      (search.constructor !== Array && search.constructor !== Object)
    ) {
      return false;
    }
    for (var i = 0; i < search.length; i++) {
      if (search[i] === key) {
        return true;
      }
    }
    return key in search;
  }

  isKana(str: any) {
    if (str && str != "") {
      // 旧実装はPHPのバイト列正規表現を移植したものだったが、入力だけを
      // UTF-8バイト列表現に変換する一方でパターン内の「ー」はU+30FCの
      // 1文字のままだったため、長音「ー」(バイト列では \xE3\x83\xBC の3文字)が
      // 決してマッチせず弾かれていた(例:「ジョージ」「レー」)。
      // [ァ-ヶ] は旧パターンのバイト範囲(U+30A1〜U+30F6)と同一。そこに「ー」を加える
      let regex = /^[ァ-ヶー]+$/;
      if (regex.test(str)) {
        return true;
      }
      return false;
    }
    return true;
  }

  isValidZen(str: any) {
    if (str && str != "") {
      let regex = /(?:\xEF\xBD[\xA1-\xBF]|\xEF\xBE[\x80-\x9F])|[\x20-\x7E]/g;
      str = unescape(encodeURIComponent(str));
      if (regex.test(str)) {
        return false;
      }
      return true;
    }
    return true;
  }

  // [F-14] デッドコード: プロジェクト内で一度も呼ばれていない。
  //   加えて2つのバグがある:
  //   1. 324行目 if(isIOS || isIOS) — isMacLike を使うべきところが isIOS の重複。Macが判定されない
  //   2. window.navigator.platform は MDN で非推奨(deprecated)。userAgentData.platform を使うべき
  //   使用する場合は上記を修正すること。
  isAppleDevices() {
    let isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(window.navigator.platform);
    let isIOS = /(iPhone|iPod|iPad)/i.test(window.navigator.platform);
    if (isIOS || isIOS) {
      return true;
    } else {
      return false;
    }
  }

  b64EncodeUnicode(str: any) {
    return btoa(
      encodeURIComponent(str).replace(
        /%([0-9A-F]{2})/g,
        function (match: any, p1: any) {
          return String.fromCharCode(parseInt(p1, 16));
        }
      )
    );
  }

  positiveIntOnly() {
    let self = this;
    self.jQuery(function () {
      /* POSITIVE INTEGER NUMBER ONLY */
      self.jQuery(".positiveIntOnly").each(function () {
        new Cleave(self.jQuery(this), {
          numeral: true,
          numeralPositiveOnly: true,
          numeralDecimalMark: "",
          delimiter: "",
        });
      });
    });
  }

  setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  scrollToTop() {
    this.jQuery("html, body").animate({ scrollTop: 0 }, 200);
  }

  convertZenToHan(value: any = "") {
    let newValue = String(value);
    newValue = newValue.replace(/[　]/g, " ");
    newValue = newValue.replace(
      /[Ａ-Ｚａ-ｚ０-９－！”＃＄％＆’（）＝＜＞，．？＿［］｛｝＠＾～￥]/g,
      function (s: any) {
        return String.fromCharCode(s.charCodeAt(0) - 65248);
      }
    );
    return newValue;
  }

  /**
   * ref: https://gist.github.com/kamiaka/3909952
   * Convert "Kana" one from another
   * (zen-kaku, han-kaku and more)
   *
   * @param string str
   * @param string option (optionaly)
   * @return string converted string
   */
  convertKana(str, option) {
    option = option || "KV";
    if (option.match("K")) {
      if (option.match("V")) {
        // han-kaku katakana (with daku-ten) to zen-kaku kata-kana
        str = str
          .replace(
            /([\uff66\uff73\uff76-\uff84\uff8a-\uff8e\uff9c])\uff9e/g,
            (m, c) => {
              const f = {
                0xff76: 0x30ac,
                0xff77: 0x30ae,
                0xff78: 0x30b0,
                0xff79: 0x30b2,
                0xff7a: 0x30b4,
                0xff7b: 0x30b6,
                0xff7c: 0x30b8,
                0xff7d: 0x30ba,
                0xff7e: 0x30bc,
                0xff7f: 0x30be,
                0xff80: 0x30c0,
                0xff81: 0x30c2,
                0xff82: 0x30c5,
                0xff83: 0x30c7,
                0xff84: 0x30c9,
                0xff8a: 0x30d0,
                0xff8b: 0x30d3,
                0xff8c: 0x30d6,
                0xff8d: 0x30d9,
                0xff8e: 0x30dc,
                0xff73: 0x30f4,
                0xff9c: 0x30f7,
                0xff66: 0x30fa,
              };
              return String.fromCharCode(f[c.charCodeAt(c)]);
            }
          )
          .replace(/([\uff8a-\uff8e])\uff9f/g, (m, c) => {
            const f = {
              0xff8a: 0x30d1,
              0xff8b: 0x30d4,
              0xff8c: 0x30d7,
              0xff8d: 0x30da,
              0xff8e: 0x30dd,
            };
            return String.fromCharCode(f[c.charCodeAt(c)]);
          });
      }
      // han-kaku kata-kana to zen-kaku kata-kana
      str = str.replace(/[\uff61-\uff9d]/g, (c) => {
        const m = {
          0xff61: 0x3002,
          0xff62: 0x300c,
          0xff63: 0x300d,
          0xff64: 0x3001,
          0xff65: 0x30fb,
          0xff66: 0x30f2,
          0xff67: 0x30a1,
          0xff68: 0x30a3,
          0xff69: 0x30a5,
          0xff6a: 0x30a7,
          0xff6b: 0x30a9,
          0xff6c: 0x30e3,
          0xff6d: 0x30e5,
          0xff6e: 0x30e7,
          0xff6f: 0x30c3,
          0xff70: 0x30fc,
          0xff71: 0x30a2,
          0xff72: 0x30a4,
          0xff73: 0x30a6,
          0xff74: 0x30a8,
          0xff75: 0x30aa,
          0xff76: 0x30ab,
          0xff77: 0x30ad,
          0xff78: 0x30af,
          0xff79: 0x30b1,
          0xff7a: 0x30b3,
          0xff7b: 0x30b5,
          0xff7c: 0x30b7,
          0xff7d: 0x30b9,
          0xff7e: 0x30bb,
          0xff7f: 0x30bd,
          0xff80: 0x30bf,
          0xff81: 0x30c1,
          0xff82: 0x30c4,
          0xff83: 0x30c6,
          0xff84: 0x30c8,
          0xff85: 0x30ca,
          0xff86: 0x30cb,
          0xff87: 0x30cc,
          0xff88: 0x30cd,
          0xff89: 0x30ce,
          0xff8a: 0x30cf,
          0xff8b: 0x30d2,
          0xff8c: 0x30d5,
          0xff8d: 0x30d8,
          0xff8e: 0x30db,
          0xff8f: 0x30de,
          0xff90: 0x30df,
          0xff91: 0x30e0,
          0xff92: 0x30e1,
          0xff93: 0x30e2,
          0xff94: 0x30e4,
          0xff95: 0x30e6,
          0xff96: 0x30e8,
          0xff97: 0x30e9,
          0xff98: 0x30ea,
          0xff99: 0x30eb,
          0xff9a: 0x30ec,
          0xff9b: 0x30ed,
          0xff9c: 0x30ef,
          0xff9d: 0x30f3,
        };
        return String.fromCharCode(m[c.charCodeAt(0)]);
      });
    } else if (option.match("H")) {
      if (option.match("V")) {
        // han-kaku kata-kana (with daku-ten) to zen-kaku hira-gana
        str = str
          .replace(/([\uff73\uff76-\uff84\uff8a-\uff8e])\uff9e/g, (m, c) => {
            const f = {
              0xff73: 0x3094,
              0xff76: 0x304c,
              0xff77: 0x304e,
              0xff78: 0x3050,
              0xff79: 0x3052,
              0xff7a: 0x3054,
              0xff7b: 0x3056,
              0xff7c: 0x3058,
              0xff7d: 0x305a,
              0xff7e: 0x305c,
              0xff7f: 0x305e,
              0xff80: 0x3060,
              0xff81: 0x3062,
              0xff82: 0x3065,
              0xff83: 0x3067,
              0xff84: 0x3069,
              0xff8a: 0x3070,
              0xff8b: 0x3073,
              0xff8c: 0x3076,
              0xff8d: 0x3079,
              0xff8e: 0x307c,
              // 0xff9c:0x30f7, 0xff66:0x30fa // vwa vwo
            };
            return String.fromCharCode(f[c.charCodeAt(c)]);
          })
          .replace(/([\uff8a-\uff8e])\uff9f/g, (m, c) => {
            const f = {
              0xff8a: 0x3071,
              0xff8b: 0x3074,
              0xff8c: 0x3077,
              0xff8d: 0x307a,
              0xff8e: 0x307d,
            };
            return String.fromCharCode(f[c.charCodeAt(c)]);
          });
      }
      // han-kaku kata-kana to zen-kaku hira-gana
      str = str.replace(/[\uff61-\uff9d]/g, (c) => {
        const f = {
          0xff61: 0x3002,
          0xff62: 0x300c,
          0xff63: 0x300d,
          0xff64: 0x3001,
          0xff65: 0x30fb,
          0xff66: 0x3092,
          0xff67: 0x3041,
          0xff68: 0x3043,
          0xff69: 0x3045,
          0xff6a: 0x3047,
          0xff6b: 0x3049,
          0xff6c: 0x3083,
          0xff6d: 0x3085,
          0xff6e: 0x3087,
          0xff6f: 0x3063,
          0xff70: 0x30fc,
          0xff71: 0x3042,
          0xff72: 0x3044,
          0xff73: 0x3046,
          0xff74: 0x3048,
          0xff75: 0x304a,
          0xff76: 0x304b,
          0xff77: 0x304d,
          0xff78: 0x304f,
          0xff79: 0x3051,
          0xff7a: 0x3053,
          0xff7b: 0x3055,
          0xff7c: 0x3057,
          0xff7d: 0x3059,
          0xff7e: 0x305b,
          0xff7f: 0x305d,
          0xff80: 0x305f,
          0xff81: 0x3061,
          0xff82: 0x3064,
          0xff83: 0x3066,
          0xff84: 0x3068,
          0xff85: 0x306a,
          0xff86: 0x306b,
          0xff87: 0x306c,
          0xff88: 0x306d,
          0xff89: 0x306e,
          0xff8a: 0x306f,
          0xff8b: 0x3072,
          0xff8c: 0x3075,
          0xff8d: 0x3078,
          0xff8e: 0x307b,
          0xff8f: 0x307e,
          0xff90: 0x307f,
          0xff91: 0x3080,
          0xff92: 0x3081,
          0xff93: 0x3082,
          0xff94: 0x3084,
          0xff95: 0x3086,
          0xff96: 0x3088,
          0xff97: 0x3089,
          0xff98: 0x308a,
          0xff99: 0x308b,
          0xff9a: 0x308c,
          0xff9b: 0x308d,
          0xff9c: 0x308f,
          0xff9d: 0x3093,
        };
        return String.fromCharCode(f[c.charCodeAt(0)]);
      });
    } else if (option.match("k")) {
      // zen-kaku kata-kana to han-kaku kata-kana
      str = str
        .replace(
          /[\u3001\u3002\u300c\u300d\u30a1-\u30ab\u30ad\u30af\u30b1\u30b3\u30b5\u30b7\u30b9\u30bb\u30bd\u30bf\u30c1\u30c3\u30c4\u30c6\u30c8\u30ca-\u30cf\u30d2\u30d5\u30d8\u30db\u30de\u30df-\u30ed\u30ef\u30f2\u30f3\u30fb]/g,
          (c) => {
            const f = {
              0x3001: 0xff64,
              0x3002: 0xff61,
              0x300c: 0xff62,
              0x300d: 0xff63,
              0x30a1: 0xff67,
              0x30a2: 0xff71,
              0x30a3: 0xff68,
              0x30a4: 0xff72,
              0x30a5: 0xff69,
              0x30a6: 0xff73,
              0x30a7: 0xff6a,
              0x30a8: 0xff74,
              0x30a9: 0xff6b,
              0x30aa: 0xff75,
              0x30ab: 0xff76,
              0x30ad: 0xff77,
              0x30af: 0xff78,
              0x30b1: 0xff79,
              0x30b3: 0xff7a,
              0x30b5: 0xff7b,
              0x30b7: 0xff7c,
              0x30b9: 0xff7d,
              0x30bb: 0xff7e,
              0x30bd: 0xff7f,
              0x30bf: 0xff80,
              0x30c1: 0xff81,
              0x30c3: 0xff6f,
              0x30c4: 0xff82,
              0x30c6: 0xff83,
              0x30c8: 0xff84,
              0x30ca: 0xff85,
              0x30cb: 0xff86,
              0x30cc: 0xff87,
              0x30cd: 0xff88,
              0x30ce: 0xff89,
              0x30cf: 0xff8a,
              0x30d2: 0xff8b,
              0x30d5: 0xff8c,
              0x30d8: 0xff8d,
              0x30db: 0xff8e,
              0x30de: 0xff8f,
              0x30df: 0xff90,
              0x30e0: 0xff91,
              0x30e1: 0xff92,
              0x30e2: 0xff93,
              0x30e3: 0xff6c,
              0x30e4: 0xff94,
              0x30e5: 0xff6d,
              0x30e6: 0xff95,
              0x30e7: 0xff6e,
              0x30e8: 0xff96,
              0x30e9: 0xff97,
              0x30ea: 0xff98,
              0x30eb: 0xff99,
              0x30ec: 0xff9a,
              0x30ed: 0xff9b,
              0x30ef: 0xff9c,
              0x30f2: 0xff66,
              0x30f3: 0xff9d,
              0x30fb: 0xff65,
            };
            return String.fromCharCode(f[c.charCodeAt(0)]);
          }
        )
        .replace(
          /[\u30ac\u30ae\u30b0\u30b2\u30b4\u30b6\u30b8\u30ba\u30bc\u30be\u30c0\u30c2\u30c5\u30c7\u30c9\u30d0\u30d3\u30d6\u30d9\u30dc\u30f4\u30f7\u30fa]/g,
          (c) => {
            // with daku-ten
            const f = {
              0x30ac: 0xff76,
              0x30ae: 0xff77,
              0x30b0: 0xff78,
              0x30b2: 0xff79,
              0x30b4: 0xff7a,
              0x30b6: 0xff7b,
              0x30b8: 0xff7c,
              0x30ba: 0xff7d,
              0x30bc: 0xff7e,
              0x30be: 0xff7f,
              0x30c0: 0xff80,
              0x30c2: 0xff81,
              0x30c5: 0xff82,
              0x30c7: 0xff83,
              0x30c9: 0xff84,
              0x30d0: 0xff8a,
              0x30d3: 0xff8b,
              0x30d6: 0xff8c,
              0x30d9: 0xff8d,
              0x30dc: 0xff8e,
              0x30f4: 0xff73,
              0x30f7: 0xff9c,
              0x30fa: 0xff66,
            };
            return String.fromCharCode(f[c.charCodeAt(0)]) + "\uff9e";
          }
        )
        .replace(/[\u30d1\u30d4\u30d7\u30da\u30dd]/g, (c) => {
          // with han-daku-ten
          const f = {
            0x30d1: 0xff8a,
            0x30d4: 0xff8b,
            0x30d7: 0xff8c,
            0x30da: 0xff8d,
            0x30dd: 0xff8e,
          };
          return String.fromCharCode(f[c.charCodeAt(0)]) + "\uff9f";
        });
    } else if (option.match("h")) {
      // zen-kaku hira-gana to han-kaku kata-kana
      str = str
        .replace(
          /[\u3001\u3002\u300c\u300d\u3041-\u304b\u304d\u304f\u3051\u3053\u3055\u3057\u3059\u305b\u305d\u305f\u3061\u3063\u3064\u3066\u3068\u306a-\u306f\u3072\u3075\u3078\u307b\u307e\u307f-\u308d\u308f\u3092\u3093\u30fb]/g,
          (c) => {
            const f = {
              0x3001: 0xff64,
              0x3002: 0xff61,
              0x300c: 0xff62,
              0x300d: 0xff63,
              0x3041: 0xff67,
              0x3042: 0xff71,
              0x3043: 0xff68,
              0x3044: 0xff72,
              0x3045: 0xff69,
              0x3046: 0xff73,
              0x3047: 0xff6a,
              0x3048: 0xff74,
              0x3049: 0xff6b,
              0x304a: 0xff75,
              0x304b: 0xff76,
              0x304d: 0xff77,
              0x304f: 0xff78,
              0x3051: 0xff79,
              0x3053: 0xff7a,
              0x3055: 0xff7b,
              0x3057: 0xff7c,
              0x3059: 0xff7d,
              0x305b: 0xff7e,
              0x305d: 0xff7f,
              0x305f: 0xff80,
              0x3061: 0xff81,
              0x3063: 0xff6f,
              0x3064: 0xff82,
              0x3066: 0xff83,
              0x3068: 0xff84,
              0x306a: 0xff85,
              0x306b: 0xff86,
              0x306c: 0xff87,
              0x306d: 0xff88,
              0x306e: 0xff89,
              0x306f: 0xff8a,
              0x3072: 0xff8b,
              0x3075: 0xff8c,
              0x3078: 0xff8d,
              0x307b: 0xff8e,
              0x307e: 0xff8f,
              0x307f: 0xff90,
              0x3080: 0xff91,
              0x3081: 0xff92,
              0x3082: 0xff93,
              0x3083: 0xff6c,
              0x3084: 0xff94,
              0x3085: 0xff6d,
              0x3086: 0xff95,
              0x3087: 0xff6e,
              0x3088: 0xff96,
              0x3089: 0xff97,
              0x308a: 0xff98,
              0x308b: 0xff99,
              0x308c: 0xff9a,
              0x308d: 0xff9b,
              0x308f: 0xff9c,
              0x3092: 0xff66,
              0x3093: 0xff9d,
              0x30fb: 0xff65,
            };
            return String.fromCharCode(f[c.charCodeAt(0)]);
          }
        )
        .replace(
          /[\u304c\u304e\u3050\u3052\u3054\u3056\u3058\u305a\u305c\u305e\u3060\u3062\u3065\u3067\u3069\u3070\u3073\u3076\u3079\u307c\u3094]/g,
          (c) => {
            // with daku-ten
            const f = {
              0x304c: 0xff76,
              0x304e: 0xff77,
              0x3050: 0xff78,
              0x3052: 0xff79,
              0x3054: 0xff7a,
              0x3056: 0xff7b,
              0x3058: 0xff7c,
              0x305a: 0xff7d,
              0x305c: 0xff7e,
              0x305e: 0xff7f,
              0x3060: 0xff80,
              0x3062: 0xff81,
              0x3065: 0xff82,
              0x3067: 0xff83,
              0x3069: 0xff84,
              0x3070: 0xff8a,
              0x3073: 0xff8b,
              0x3076: 0xff8c,
              0x3079: 0xff8d,
              0x307c: 0xff8e,
              0x3094: 0xff73,
            };
            return String.fromCharCode(f[c.charCodeAt(0)]) + "\uff9e";
          }
        )
        .replace(/[\u3071\u3074\u3077\u307a\u307d]/g, (c) => {
          // with han-daku-ten
          const f = {
            0x3071: 0xff8a,
            0x3074: 0xff8b,
            0x3077: 0xff8c,
            0x307a: 0xff8d,
            0x307d: 0xff8e,
          };
          return String.fromCharCode(f[c.charCodeAt(0)]) + "\uff9f";
        });
    }
    if (option.match("c")) {
      // zen-kaku kata-kana to zen-kaku hira-gana
      str = str.replace(/[\u30a1-\u30f6]/g, (c) =>
        String.fromCharCode(c.charCodeAt(0) - 0x0060)
      );
    } else if (option.match("C")) {
      // zen-kaku hira-gana to zen-kaku kata-kana
      str = str.replace(/[\u3041-\u3086]/g, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 0x0060)
      );
    }
    if (option.match("r")) {
      // zen-kaku alphabets to han-kaku
      str = str.replace(/[\uff21-\uff3a\uff41-\uff5a]/g, (c) =>
        String.fromCharCode(c.charCodeAt(0) - 0xfee0)
      );
    } else if (option.match("R")) {
      // han-kaku alphabets to zen-kaku
      str = str.replace(/[A-Za-z]/g, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 0xfee0)
      );
    }
    if (option.match("n")) {
      // zen-kaku numbers to han-kaku
      str = str.replace(/[\uff10-\uff19]/g, (c) =>
        String.fromCharCode(c.charCodeAt(0) - 0xfee0)
      );
    } else if (option.match("N")) {
      // han-kaku numbers to zen-kaku
      str = str.replace(/[\u0030-\u0039]/g, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 0xfee0)
      );
    }
    // Characters included in "a", "A" options are
    // "!" - "~" excluding '"', "'", "\", "~"
    if (option.match("a")) {
      // zen-kaku alphabets and numbers to han-kaku
      str = str.replace(
        /[\uff01\uff03-\uff06\uff08-\uff3b\uff3d-\uff5d]/g,
        (c) => String.fromCharCode(c.charCodeAt(0) - 0xfee0)
      );
    } else if (option.match("A")) {
      // han-kaku alphabets and numbers to zen-kaku
      str = str.replace(
        /[\u0021\u0023-\u0026\u0028-\u005b\u005d-\u007d]/g,
        (c) => String.fromCharCode(c.charCodeAt(0) + 0xfee0)
      );
    }
    if (option.match("s")) {
      // zen-kaku space to han-kaku
      str = str.replace(/\u3000/g, "\u0020");
    } else if (option.match("S")) {
      // han-kaku space to zen-kaku
      str = str.replace(/\u0020/g, "\u3000");
    }
    return str;
  }

  convertFormInputZenToHan(form: any) {
    for (let key in form.value) {
      if (form.controls[key]) {
        if (
          !this.isNumeric(form.controls[key].value) &&
          form.controls[key].value &&
          form.controls[key].value != ""
        ) {
          form.controls[key].setValue(
            this.convertZenToHan(form.controls[key].value)
          );
        }
      }
    }
  }

  isMobile() {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor);
    return check;
  }

  /* JQUERY */
  zenToHan(selector: string = ".zenToHan", numberOnly: boolean = true) {
    let self = this;
    let zenToHanInput = function (e: any) {
      let v = e.value;
      let old = e.value;
      return function () {
        if (old != (v = e.value)) {
          old = v;
          let str = self.jQuery(this).val();
          str = str.replace(
            /[Ａ-Ｚａ-ｚ０-９－！”＃＄％＆’（）＝＜＞，．？＿［］｛｝＠＾～￥]/g,
            function (s: any) {
              return String.fromCharCode(s.charCodeAt(0) - 65248);
            }
          );

          if (numberOnly) {
            str = str.replace(
              /[Ａ-Ｚａ-ｚA-Za-z－！”＃＄％＆’（）＝＜＞，．？＿［］｛｝＠＾～￥\s]/g,
              function (s) {
                return "";
              }
            );
          }

          self.jQuery(this).val(str);
        }
      };
    };
    self.jQuery(function () {
      self.jQuery(selector).each(function () {
        /* ZEN TO HAN */
        /* self.jQuery(this).bind("keyup", zenToHanInput(this)); */

        self
          .jQuery(this)
          .on("input keydown keyup keypress", function (event: any) {
            event = event || window.event;

            /* NUMBER ONLY */
            if (numberOnly) {
              let key = event.keyCode || event.which || event.charCode || 0;
              let ctrl =
                event.ctrlKey ||
                event.metaKey ||
                (key === 17 ? true : false); /* ctrl detection */
              // let ctrl = event.ctrlKey ? event.ctrlKey : ((key === 17) ? true : false); /* ctrl detection */

              /* ACCEPT: NUMBER (JAPANESE NUMBER INCLUDES), CTRL+A, CTRL+C, CTRL+V, ARROW LEFT RIGHT, ENTER */
              if (
                (key == 65 && ctrl) ||
                (key == 86 && ctrl) ||
                (key == 67 && ctrl) ||
                key === 8 ||
                key === 9 ||
                key === 13 ||
                key === 46 ||
                key === 35 ||
                key === 36 ||
                key === 37 ||
                key === 39
              ) {
                return true;
              } else if ((key < 48 || key > 57) && (key < 96 || key > 105)) {
                return false;
              }
            }

            /* MAX LENGTH */
            if ($(this).attr("maxlength")) {
              let len = $(this).val().length + 1;
              let max = parseInt($(this).attr("maxlength"));

              if (len > max) {
                event.preventDefault();
                return false;
              }
            }

            return true;
          });
      });
    });
  }

  getBBTelParts(fullTel: string = "") {
    let returnData = [];

    fullTel = String(fullTel);
    if (fullTel.length === 10) {
      returnData.push(fullTel.substr(0, 2));
      returnData.push(fullTel.substr(2, 4));
      returnData.push(fullTel.substr(6));
    } else if (fullTel.length === 11) {
      returnData.push(fullTel.substr(0, 3));
      returnData.push(fullTel.substr(3, 4));
      returnData.push(fullTel.substr(7));
    } else {
      returnData.push(fullTel.substr(0, 2));
      returnData.push(fullTel.substr(2, 4));
      returnData.push(fullTel.substr(6));
    }

    return returnData;
  }

  isRomanAlphabetNNumber(str: any) {
    if (str && str != "") {
      let regex = /^[a-z\d]*$/gi;
      str = unescape(encodeURIComponent(str));
      if (regex.test(str)) {
        return true;
      }
      return false;
    }
    return true;
  }

  checkAlpha(str: any) {
    if (str && str != "") {
      let regex = /^[ a-zA-Z]+$/g;
      if (regex.test(str)) {
        return true;
      }
      return false;
    }
    return true;
  }

  isProduction() {
    return (
      window.location.hostname == `www.${this.appConfig.productionDomain}` ||
      window.location.hostname == this.appConfig.productionDomain
    );
  }
}
